import { PublicationSheetWithId } from '@livv/models';
import { query, Query, where } from 'firebase/firestore';
import { useErrorHandler } from 'react-error-boundary';
import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import { publicationSheetsCollection } from '@utils/collections';
import { useBookPageContext } from '@utils/context/book';

export const useSheetByNumber = (
    sheetNumber: number,
    above: boolean,
): PublicationSheetWithId | undefined => {
    const { bookId } = useBookPageContext();
    const [sheets, loading, error] = useCollectionDataOnce<PublicationSheetWithId>(
        query(
            publicationSheetsCollection,
            where('keyword.treeId', '==', bookId),
            where('number', above ? '>' : '<', sheetNumber),
            where('isPublished', '==', true),
        ) as Query<PublicationSheetWithId>,
    );
    useErrorHandler(error);
    if (loading || !sheets?.length) return undefined;

    return sheets.at(above ? 0 : sheets.length - 1);
};
